import {
  cond,
  defaultTo,
  pipe,
  startsWith,
  stubFalse,
  stubTrue,
} from 'lodash/fp'
import { combineReducers } from 'redux'
import { ignoreActions } from 'redux-ignore'

import { getWithFallback } from '@masterplandev/utils'

import core from '@/core/reducer'
import dashboard from '@/dashboard/reducer'
import learngroup from '@/learngroup/reducer'
import learnpathsAssigned from '@/learnpaths-assigned/reducer'
import mediaSummary from '@/learnpaths-media/reducers/mediaSummary.reducer'
import learnpaths from '@/learnpaths/reducer'
import lectures from '@/lecture/reducer'
import quiz from '@/quiz/reducer'
import scorm from '@/scorm/reducer'
import user from '@/user/reducer'

const getUrl = getWithFallback([
  'payload.url',
  'options.url',
  'payload.options.url',
  'payload.request.url',
  'meta.previousAction.payload.options.url',
  'meta.previousAction.payload.request.url',
])

export default () =>
  combineReducers({
    core,
    dashboard,
    learngroup,
    learnpaths: ignoreActions(
      learnpaths as any,
      pipe(
        getUrl,
        defaultTo('/learnpaths'),
        cond([
          [startsWith('/learnpaths/assigned'), stubTrue],
          [startsWith('/lectures'), stubTrue],
          [stubTrue, stubFalse],
        ]),
      ),
    ),
    learnpathsAssigned: ignoreActions(
      learnpathsAssigned as any,
      pipe(
        getUrl,
        defaultTo('/learnpaths/assigned'),
        cond([
          [startsWith('/learnpaths/assigned'), stubFalse],
          [startsWith('/learnpaths'), stubTrue],
          [stubTrue, stubFalse],
        ]),
      ),
    ),
    mediaSummary,
    lectures: ignoreActions(
      lectures as any,
      pipe(
        getUrl,
        defaultTo('/lectures'),
        cond([
          [startsWith('/learnpaths/assigned'), stubFalse],
          [startsWith('/learnpaths'), stubTrue],
          [stubTrue, stubFalse],
        ]),
      ),
    ),
    quiz,
    scorm,
    user,
  })
